"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDispatcherCreateTaskRequest = void 0;
var superstruct_1 = require("superstruct");
var Address_1 = require("../../types/Address");
var Customer_1 = require("../../types/Customer");
var isStruct_1 = require("../../utils/isStruct");
var DispatcherCreateTaskRequestStruct = (0, superstruct_1.type)({
    externalOrderId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    externalOrderNumber: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    warehouseId: (0, superstruct_1.string)(),
    noteFromCustomer: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    isIdCheckRequired: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    customer: Customer_1.CustomerStruct,
    address: Address_1.AddressStruct,
});
function isDispatcherCreateTaskRequest(obj) {
    return (0, isStruct_1.isStruct)(obj, DispatcherCreateTaskRequestStruct, "DispatcherCreateTaskRequest");
}
exports.isDispatcherCreateTaskRequest = isDispatcherCreateTaskRequest;
